import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useCallback, useEffect, useMemo, useState } from "react";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { viewProviderTool } from "../../Services/Provider/providerService";
import EditProvider from "../ViewProvider/EditProviderTool";
import Dialog from "../../Components/Modal/Dialog";
import { useLocation } from "react-router-dom";
import Loader from "../Loader";
import GeneralToast from "../Toaster";

const ViewTools = () => {
  const [isViewTool, setIsViewTool] = useState(false);
  const [selectedTool, setSelectedTool] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [data, setData] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const providerId = queryParams.get("providerId");

  const columnDefs = useMemo(
    () => [
      {
        field: "id",
        headerCheckboxSelection: false,
        checkboxSelection: false,
        showDisabledCheckboxes: false,
        headerName: "Tool ID",
        width: 420,
      },
      { field: "name", headerName: "Tool Name", width: 300 },
      { field: "type", headerName: "Tool Type", width: 300 },
      {
        field: "view",
        headerName: "View Tool",
        cellRenderer: (params) => {
          return (
            <div className="flex items-center h-full">
              <MdOutlineRemoveRedEye
                onClick={() => {
                  setIsViewTool(true);
                  setSelectedTool(params.data);
                }}
                style={{
                  color: "#47B7CF",
                  fontSize: "large",
                  cursor: "pointer",
                }}
              />
            </div>
          );
        },
        width: 400,
      },
    ],
    []
  );

  const fetchTools = useCallback(() => {
    setIsLoading(true);
    const payload = {
      input: {
        entityType: "Tool",
        property: "providerId",
        value: providerId,
        operator: providerId ? "or" : "neq",
      },
    };
    viewProviderTool(payload)
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.status === 200) {
          const tools = res?.data?.data?.map((provider) => ({
            ...provider.Tool,
          }));
          setData(tools);
        } else {
          setData([]);
          setErrorMessage(
            res?.response?.data?.errorMessage ||
              res?.message ||
              "Something went wrong"
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorMessage("Something went wrong");
      });
  }, [providerId]);

  useEffect(() => {
    fetchTools();
  }, [fetchTools]);

  const defaultColDef = useMemo(
    () => ({
      filter: true,
      sortable: true,
    }),
    []
  );

  const onCloseViewTool = (position) => {
    setIsViewTool(false);
    if (position === "success") {
      fetchTools();
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <p className="flex items-center justify-center mt-20 mb-4 text-lg text-[#0e76a8]">
        <b>View Tools</b>
      </p>
      <div
        className="ag-theme-alpine"
        style={{ height: "calc(100vh - 150px)", margin: "5px" }}
      >
        <AgGridReact
          rowData={data}
          columnDefs={columnDefs}
          rowSelection="multiple"
          animaterowData={true}
          suppressPaginationPanel={true}
          overlayNoRowsTemplate={`<span style="padding: 10px; border: var(--ag-borders) var(--ag-border-color); background: var(--ag-background-color); border-radius: var(--ag-card-radius); box-shadow: var(--ag-card-shadow);padding: var(--ag-grid-size); ">${
            !isLoading ? "" : "No Data"
          }</span>`}
          suppressScrollOnNewData={true}
          defaultColDef={defaultColDef}
        />
      </div>
      {isViewTool && (
        <Dialog
          title="View Tool"
          style={{ background: "rgba(241, 255, 253, 0.80)" }}
          onClose={onCloseViewTool}
        >
          <EditProvider
            selectedProviderTool={selectedTool}
            onClose={onCloseViewTool}
            type={"Tool"}
            providerId={providerId}
            setErrorMessage={setErrorMessage}
          />
        </Dialog>
      )}
      {errorMessage && <GeneralToast type="error" message={errorMessage} />}
    </>
  );
};

export default ViewTools;
